import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { InputComponent } from '../input/input.component';
import { FormulaireService } from 'src/app/saisie/formulaire.service';
import { LibellesService } from 'src/app/core/libelles.service';
import { FiltreService } from '../../filtre.service';
import { StringInputComponent } from '../string-input/string-input.component';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';

@Component({
  selector: 'bis-string-inline-input',
  templateUrl: './string-inline-input.component.html'
})
export class StringInlineInputComponent extends StringInputComponent {
  @Input()
  longueurMax = 1000;
  @Input() placeholder = '';
  @Input()
    classeSupplementaire: string = 'text-right';
    
  // rootForm: FormGroup;   deja declare en heritage
  libelle$: BehaviorSubject<string>;
  constructor(
    protected formulaireService: FormulaireService,
    protected libelleService: LibellesService,
    protected filtreService: FiltreService,
    public modeRenduService: ModeRenduService
    ) {
      super(formulaireService, libelleService, filtreService, modeRenduService);
  }
}
